export default __webpack_public_path__ + "assets/rice-logo-white-transp.png";